/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains typings and utilities for creating reducers.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/*
 * Used to get access to the API types and requests
 */
import * as Dtos from '../../api/dtos';

/*
 * --------------------------------------------------------------------------------
 * Enumerations
 * --------------------------------------------------------------------------------
 */

export enum RequestState {
    None = 1,
    Pending = 2,
    Success = 3,
    Failure = 4,
    Cancel = 5
}

/*
 * --------------------------------------------------------------------------------
 * Interfaces
 * --------------------------------------------------------------------------------
 */

export interface IRequestState {
    state: RequestState;
    responseStatus?: Dtos.ResponseStatus;
}


// WEBPACK FOOTER //
// ./src/store/reducers/index.ts